export type NavigationGroup = 'workspace' | 'governance' | 'organisation' | 'help' | 'account';

export type NavigationItem = {
  id: string;
  label: string;
  to: string;
  group: NavigationGroup;
  external?: boolean;
};

export const isCurrentPath = (pathname: string, destination: string): boolean => {
  const target = new URL(destination, 'https://navigation.invalid').pathname.replace(/\/+$/, '') || '/';
  const current = pathname.replace(/\/+$/, '') || '/';
  return target === '/' ? current === '/' : current === target || current.startsWith(`${target}/`);
};

export const uniqueNavigation = <T extends NavigationItem>(items: readonly T[]): T[] => {
  const seen = new Set<string>();
  return items.filter(item => {
    if (seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
};
